/**
 * Hover zoom (magnifying lens) on product gallery images - desktop only.
 * Shows a circular magnified area that follows the cursor over the main image.
 */

const LENS_SIZE = 280;
const ZOOM_LEVEL = 2.5;

const hoverMedia = window.matchMedia('(hover: hover)');
const largeScreen = window.matchMedia('(min-width: 1024px)');

function isHoverZoomEnabled() {
  return hoverMedia.matches && largeScreen.matches;
}

function createLens() {
  const lens = document.createElement('div');
  lens.className = 'product-media-hover-zoom__lens';
  lens.setAttribute('aria-hidden', 'true');
  lens.hidden = true;

  const img = document.createElement('img');
  img.className = 'product-media-hover-zoom__lens-image';
  img.alt = '';
  img.setAttribute('loading', 'eager');
  lens.appendChild(img);

  document.body.appendChild(lens);
  return { lens, img };
}

let lensEl = null;
let lensImg = null;
let currentContainer = null;
let currentHighResUrl = null;

function getLens() {
  if (!lensEl) {
    const created = createLens();
    lensEl = created.lens;
    lensImg = created.img;
  }
  return { lens: lensEl, img: lensImg };
}

function showLens(container, highResUrl) {
  if (!isHoverZoomEnabled()) return;
  currentContainer = container;
  currentHighResUrl = highResUrl;
  const { lens, img } = getLens();
  img.src = highResUrl;
  lens.hidden = false;
}

function updateLensPosition(clientX, clientY) {
  if (!currentContainer || !lensEl || lensEl.hidden) return;

  const rect = currentContainer.getBoundingClientRect();
  const x = clientX - rect.left;
  const y = clientY - rect.top;
  const xRatio = x / rect.width;
  const yRatio = y / rect.height;

  const half = LENS_SIZE / 2;
  const zoomedW = rect.width * ZOOM_LEVEL;
  const zoomedH = rect.height * ZOOM_LEVEL;

  lensEl.style.left = `${clientX - half}px`;
  lensEl.style.top = `${clientY - half}px`;

  lensImg.style.width = `${zoomedW}px`;
  lensImg.style.height = `${zoomedH}px`;
  lensImg.style.left = `${half - xRatio * zoomedW}px`;
  lensImg.style.top = `${half - yRatio * zoomedH}px`;
}

function hideLens() {
  currentContainer = null;
  currentHighResUrl = null;
  if (lensEl) {
    lensEl.hidden = true;
  }
}

function handlePointerEnter(e) {
  if (!isHoverZoomEnabled()) return;
  if (!(e.target instanceof Element)) return;
  const container = e.target.closest('[data-hover-zoom]');
  if (!container) return;
  const url = container.getAttribute('data-high-res-url');
  if (!url) return;
  showLens(container, url);
  updateLensPosition(e.clientX, e.clientY);
}

function handlePointerMove(e) {
  if (!(e.target instanceof Element)) return;
  const container = e.target.closest('[data-hover-zoom]');
  if (!container) {
    if (currentContainer) hideLens();
    return;
  }
  const url = container.getAttribute('data-high-res-url');
  if (!url) return;
  if (container !== currentContainer) {
    showLens(container, url);
  }
  updateLensPosition(e.clientX, e.clientY);
}

function handlePointerLeave(e) {
  if (!(e.target instanceof Element)) return;
  const container = e.target.closest('[data-hover-zoom]');
  if (container) {
    const related = e.relatedTarget;
    if (related && container.contains(related)) return;
    hideLens();
  }
}

let listenersAttached = false;

function init() {
  if (!isHoverZoomEnabled() || listenersAttached) return;
  listenersAttached = true;

  document.addEventListener('pointerenter', handlePointerEnter, { passive: true, capture: true });
  document.addEventListener('pointermove', handlePointerMove, { passive: true, capture: true });
  document.addEventListener('pointerleave', handlePointerLeave, { passive: true, capture: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', () => {
  listenersAttached = false;
  init();
});
